module.exports = __webpack_public_path__ + "static/media/open.8f7b83c5.svg";